class FeedCtrl {

    constructor($scope, $routeParams, ApiService, CONTENT_TYPE, EVENTS, $feedService, $uibModal) {

        this.loading = true;
        this.noResults = false;
        this.error = false;
        this.feed = null;
        this.feedData = null;
        this.revisions = [];
        this.totalItems = 0;
        this.perPage = 50;
        this.page = 1;
        this.revisionId = null;
        this.maxPages = 100;
        this.itemCount = 0;
        this.firstTime = true;
        this.selectedFile = null;
        this.updateAvailable = false;
        this.updateDate = null;
        this.tableFilter = null;
        this.isUploading = false;
        this.isUploadingUrl = false;
        this.isImporting = false;
        this.isPublishing = false;
        this.isExporting = false;
        this.$uibModal = $uibModal;
        this.$feedService = $feedService;
        this.$scope = $scope;
        this.$scope.authLoaded = false;
        this.$routeParams = $routeParams;
        this.ApiService = ApiService;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.EVENTS = EVENTS;
        this.refreshFeed();
    }

    refreshFeed() {

        this.error = false;
        this.ApiService.get(this.CONTENT_TYPE.FEED, this.$routeParams.feedId)
            .then((response) => {
                this.feed = response.data;
                this.getRevisions(this.feed.publishedRevision);
            }, (response) => {
                console.error(response);
                this.error = true;
            });
    }

    publish() {

        this.isPublishing = true;
        if(this.itemCount > 0) {
            this.$feedService.publishRevision(this.feed.id, this.revisionId)
                .then(resp => {
                    this.feed.publishedRevision = this.revisionId;
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Feed revision ' + this.revisionId + ' has now been published.'});
                    this.isPublishing = false;
                }, err => {
                    console.error(err);
                    this.isPublishing = false;
                });
        }
        else {
            this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Publishing failed - you cannot publish an empty feed.', 'messageType': 'error'});
            this.isPublishing = false;
        }
    }

    stage() {

        this.isStaging = true;

        this.$feedService.stageRevision(this.feed.id, this.revisionId)
            .then(resp => {
                this.feed.previewRevision = this.revisionId;
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Feed revision ' + this.revisionId + ' has now been staged.'});
                this.isStaging = false;
            }, err => {
                console.error(err);
                this.isStaging = false;
            });
    }

    pageUpdated(page) {
        this.refreshFeedItems();
    }

    getRevisions(publishedRevision) {
        var self = this;
        this.$feedService.getRevisions(this.feed.id, publishedRevision)
            .then((response) => {
                self.revisions = response.data;
                if (this.revisions.length === 0) {
                    self.noResults = true;
                    self.loading = false;
                } else {
                    self.selectedRevision = (!!publishedRevision)
                        ? self.revisions.filter(x => x.id === publishedRevision)[0]
                        : self.revisions[0];
                    self.refreshFeedItems();
                }
            }, (response) => {
                console.error(response);
            });
    }

    refreshFeedItems(query) {

        if(!!this.selectedRevision) {
            this.revisionId = this.selectedRevision.id;
        }
        else {
            this.revisionId = 0;
        }

        if(!(!!query)) {
            query = "*";
        }

        this.noResults = false;
        this.loading = true;
        this.$feedService.getFeedItems(this.feed.id, this.revisionId, this.page, this.perPage, query)
            .then((response) => {
                this.itemCount = response.data.count;
                this.totalItems = response.data.count > this.maxPages * this.perPage
                    ? this.maxPages * this.perPage
                    : response.data.count;
                if (response.data.count === 0) {
                    this.noResults = true;
                }
                this.feedData = response.data.items;
                this.loading = false;
            }, (response) => {
                if (response.status === 404) {
                    this.noResults = true;
                } else {
                    console.error(response);
                    this.error = true;
                }
                this.loading = false;
            });
    }

    upload() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'feed/upload-feed.html',
            controller: 'UploadFeedCtrl'
        });

        modalInstance.result.then(item => {
            this.isUploading = true;
            this.$feedService.uploadFeed(this.feed, item, false)
                .then((response) => {
                    this.getRevisions();
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Upload of file "' + item.name + '" successfully started.'});
                    this.isUploading = false;
                }, (response) => {
                    console.error(response);
                    this.isUploading = false;
                });
        }, () =>  this.isUploading = false);
    }

    uploadUrl() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'feed/upload-feed-url.html',
            controller: 'UploadFeedUrlCtrl'
        });

        modalInstance.result.then((url) => {
            this.isUploadingUrl = true;
            this.$feedService.uploadUrl(this.feed, url, {publish: false})
                .then((response) => {
                    this.refreshFeed(false);
                    this.getRevisions();
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Upload of data from "' + url + '" successfully started.'});
                    this.isUploadingUrl = false;
                }, (response) => {
                    console.error(response);
                    this.isUploadingUrl = false;
                });
        }, () =>  this.isUploadingUrl = false);
    }

    getStatusText(revisionId) {
        let statusText = "";
        if(revisionId == this.feed.publishedRevision) {
            statusText = " (Published";
            if(revisionId == this.feed.previewRevision) {
                statusText += " & Staged"
            }
            statusText += ")"
        }
        else if(revisionId == this.feed.previewRevision) {
            statusText = " (Staged)"
        }
        return statusText;
    }


}

angular.module('cpm')
    .controller('FeedCtrl', ['$scope', '$routeParams', 'ApiService', 'CONTENT_TYPE', 'EVENTS', '$feedService', '$uibModal', FeedCtrl]);
